import { APPOINTMENTS_ATTENTION_POINTS_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * Get All appointments
 * @param {Object} params
 * @param {string} params.dealerId
 */
export const fetchAll = (params, meta = {}) => ({
  type: types.FETCH_ATTENTION_POINTS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: APPOINTMENTS_ATTENTION_POINTS_URL,
      params,
    },
  },
  meta,
});

export const fetchFailure = (message, meta = {}) => ({
  type: types.FETCH_ATTENTION_POINTS_FAILURE,
  payload: message,
  error: true,
  meta
});

export const stopFetchPolling = () => ({
  type: types.FETCH_ATTENTION_POINTS_STOP_POLLING,
});

export const startFetchPolling = () => ({
  type: types.FETCH_ATTENTION_POINTS_START_POLLING,
});

export const showDrawer = () => ({
  type: types.SHOW_ATTENTION_POINTS_PANEL,
});

export const hideDrawer = () => ({
  type: types.HIDE_ATTENTION_POINTS_PANEL,
});
